import React from "react";
import Preheader from "./Preheader";
import Parters from "./Parters";
import Footer from "./Footer";
import founder from "./image/founderbrij.jpg";
import team1 from "./image/t1.jpg";
import team2 from "./image/t2.jpg";
import team3 from "./image/t31.png";
import team4 from "./image/t41.png";
import aboutus from "./image/about-us.jpg";
import { Helmet } from "react-helmet";
export default function Video() {
  return (
    <>
      <Helmet>
        <title>
          Watch New Delhi Tigers - Highlights, Interviews, and More
        </title>
        <meta
          name="title"
          content="Watch New Delhi Tigers - Highlights, Interviews, and More
"
        />
        <meta
          name="keywords"
          content=" 
New Delhi Tigers videos
New Delhi Tigers highlights
New Delhi Tigers interviews
"
        />

        <meta
          name="description"
          content="New Delhi Tigers videos showcase the team's journey in the Delhi Premier League T20. Watch highlights, player interviews, and behind-the-scenes content to get an inside look at the team's performance and spirit.

"
        />

        <link rel="canonical" href="https://newdelhitigers./about" />
      </Helmet>

      <Preheader />
      <div class="container-fluid p-0">
        <div class="breadcrumb-bg">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <div className="newheading1">
                <h5>Watch Videos</h5>
                <div className="line"></div>
              </div>{" "}
            </ol>
          </nav>
        </div>
      </div>

      <section className="about--us1">
        <div className="container-fluid">
          <div className="abou-us">
            <div className="row">
              <div className="col-md-6 col-12">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/TSIEws9HXCg?si=MX1eo9xjePMGU_ag"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>

              <div className="col-md-6 col-12">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/-mUj1onzkhU?si=P7vc_ks-29djyYky"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>

              <div className="col-md-6 col-12">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/MpVolscG2Ek?si=MCYh_76bo010d9-H" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
              <div className="col-md-6 col-12">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/SsVNmLLd5rg?si=tBo91qcMfQCFbfwk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>              </div>
              <div className="col-md-6 col-12">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/dTUIKuR-nFw?si=ixAI2Pfh8SgXjRNT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>              </div>
              <div className="col-md-6 col-12">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/Mju8Rk5Kh8Y?si=5vv6KKE3wtqpKpdH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>              </div>
              <div className="col-md-6 col-12">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/yqR2r_Eo4Kg?si=MnUpLvfRAUIWXi_A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>              </div>

              
          </div>
        </div>
        </div>

      </section>

      <Parters />
      <Footer />
    </>
  );
}
